<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Левая колонка -->
        <div class="footer-left">
          <img src="@/assets/images/logo.svg" alt="Logo" class="logo" />
        </div>
        <ul>
          <li><a href="/about">О проекте</a></li>
          <!-- <li><a href="#">Источники данных</a></li> -->
          <!-- <li><a href="#">Выписка из ЕГРЮЛ</a></li> -->
          <li><a href="/blog">Блог</a></li>
          <li><a href="/requisites">Реквизиты</a></li>
        </ul>

        <!-- Центральная колонка -->
        <div class="footer-center">
          <ul>
            <li>
              <a href="/terms_new.pdf" target="_blank" rel="noopener"
                >Пользовательское соглашение</a
              >
            </li>
            <li>
              <a href="/terms.pdf" target="_blank" rel="noopener"
                >Публичная оферта</a
              >
            </li>
            <li>
              <a href="/privacy.pdf" target="_blank" rel="noopener"
                >Политика конфиденциальности</a
              >
            </li>
            <li><a href="#">Документация API</a></li>
            <li>
              <a href="/presentation.pdf" target="_blank" rel="noopener"
                >Презентация проекта</a
              >
            </li>
          </ul>
        </div>

        <!-- Правая колонка -->
        <div class="footer-right">
          <div class="contacts">
            <p class="label">Контакты</p>
            <p class="green">ИНН 6155077624</p>
            <p class="green email">support@x-global.ru</p>
            <!-- <div class="socials">
              <a href="#">
                <img src="@/assets/images/socials/phone_green.svg" />
              </a>
              <a href="#">
                <img src="@/assets/images/socials/telegram_green.svg" />
              </a>
            </div> -->
          </div>
          <div class="address">
            <p class="label">Адрес</p>
            <p>г. Москва ул. Дубки, д. 6</p>
          </div>
        </div>
      </div>

      <div class="footer-bottom-text">Тестовый период - X-Global</div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped lang="scss">
.footer {
  background: #fff;
  padding: 40px 20px;
  font-size: 14px;
  color: #333;
}

.container {
  margin: 0 auto;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  flex-direction: row;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: flex-start;
  }

  ul,
  .footer-right {
    padding-left: 10px !important;
  }

  .footer-left {
    .logo {
      margin-bottom: -15px !important;
    }
  }
}

.green {
  color: rgba(0, 199, 130, 1) !important;
}

.footer-right {
  margin-top: -4px;
}

.footer-left {
  display: flex;
  align-items: center;
  margin-top: -7px;

  .logo {
    height: 52px;
    width: 130px;
    object-fit: cover;
  }
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
ul li {
  margin-bottom: 8px;
  font-size: 14px;
}
ul li a {
  text-decoration: none;
  color: rgba(109, 115, 124, 1);
}
ul li a:hover {
  text-decoration: underline;
}
.label {
  font-weight: 600;
  margin-bottom: 6px;
  color: rgba(109, 115, 124, 1);
  font-size: 20px;
}
.contacts p,
.address p {
  margin: 4px 0;
  font-size: 14px !important;
  font-weight: 500;
}

.email {
  color: rgba(109, 115, 124, 1);
  font-weight: 400;
}

.socials {
  display: flex;
  gap: 12px;
}

.footer-bottom-text {
  text-align: center;
  margin-top: 30px;
  color: rgba(109, 115, 124, 1);
}
</style>
